import { createContext } from 'react';
import { RouteData } from '@sitecore-jss/sitecore-jss-nextjs';

import { TitledSitecoreItem } from '../../../../types';
import { MajorLink, MenuItem, SubmenuItem } from '../../MegaMenuTypes';

export interface IHeaderContext {
  onMenuItemClick?: (menuItem: MenuItem) => void;
  openMenuItem?: (menuItem: MenuItem) => void;
  onMobileMenuClick?: () => void;
  activeSubmenuItem?: SubmenuItem;
  menuItems: MenuItem[];
  isMobileMenuOpen: boolean;
  shouldFocus: boolean;
  activeItemId: string;
  onBackClick?: () => void;
  activeMajorLink: TitledSitecoreItem<MajorLink> | null;
  onMajorCategoryHover?: (majorLink: TitledSitecoreItem<MajorLink>) => void;
  closeMenu: () => void;
  currentLocale: string;
  onLanguageSelect?: () => void;
  mediaHost: string;
  myJabraUrl?: string;
  route?: RouteData;
}

const HeaderContext = createContext<IHeaderContext>({
  menuItems: [],
  isMobileMenuOpen: false,
  shouldFocus: false,
  activeItemId: '',
  activeMajorLink: null,
  closeMenu: () => null,
  currentLocale: 'en',
  mediaHost: '',
  myJabraUrl: '',
});

export { HeaderContext };
